<template>
    <div class="plan plan--specific" v-if="subscription">
        <div>
            <strong>Aktuální plán</strong>
        </div>

        <div class="plan__name">{{ type }}</div>

        <div class="plan__price">
            <span class="plan__value" v-if="isTrial">{{ price }}</span>
            <span class="plan__value" v-if="!isTrial">{{ price }} Kč</span>
            <span class="plan__payment-period" v-if="!isTrial">bez DPH</span>
        </div>

        <div class="plan__valid">
            platnost<br><strong>{{ subscription.beginsAt | dateFormat }}</strong> -
            <strong>{{ subscription.endsAt | dateFormat }}</strong><br>
            <!--platnost <strong class="plan__ends">končí za 47 dní</strong>-->
        </div>

        <div class="plan__widgets" v-if="subscription.items.length">
            <div class="plan__widgets-heading">Aktivní balíčky</div>
            <ul class="plan__widgets-list">
                <li v-for="item in subscription.items">
                    {{ item.title }}
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
import {formatNumber} from 'domovio-core/src/system/helpers/number.helper';

export default {
    computed: {
        subscription() {
            return this.$store.getters['projects/project/subscription/subscription'];
        },
        type() {
            const {type} = this.subscription;
            if (type === 'monthly') return 'Měsíční';
            if (type === 'annually') return 'Roční';
            if (type === 'trial') return 'Zkušební';
        },
        isTrial() {
            const {type} = this.subscription;
            return type === 'trial';
        },
        price() {
            const {type, annualPrice, monthlyPrice} = this.subscription;
            if (type === 'monthly') return formatNumber(monthlyPrice.withoutVat);
            if (type === 'annually') return formatNumber(annualPrice.withoutVat);
            if (type === 'trial') return 'Zdarma';
        }
    }
}
</script>
